import { concat, findIndex, set } from 'lodash'
import { http, queryString } from 'utils'

import { SET_PROPERTY, SET_LIST, ADD_LIST, ADD_SINGLE, SET_SINGLE, SET_PAGINATION_DATA, REMOVE_LIST_ITEM, UPDATE_LIST_ITEM } from 'vx/mutations'

// state.
const state = {
    single: {},
    list: [],
    pagination: {}
}

// usertstory settings state getters.
const getters = {}

// usertstory settings actions.
const actions = {
    /**
     * Get a list of clients.
     */
    getActivityLog ({ commit }, { id, payload }) {
        commit(SET_LIST, [])
        commit(SET_PAGINATION_DATA, null)
    
        return http.get(`projects/${id}/activity-log?${queryString(payload)}`).then((response) => {
            commit(SET_LIST, response.data.data)
            commit(SET_PAGINATION_DATA, response.data.meta)
        })
    },

    /**
     * Get next page of paginated data 
     */
    getActivitiesForNextPage ({ commit, state }, { id, payload }) {
      if (state.pagination.current_page === state.pagination.last_page) {
          return Promise.reject('There are no more items to load.')
      }

      let page = state.pagination.current_page + 1

      return http.get(`projects/${id}/activity-log?${queryString(payload)}&page=${page}`).then((response) => {
          commit(ADD_LIST, response.data.data)
          commit(SET_PAGINATION_DATA, response.data.meta)

          return response
      })
    },

    /**
     * Add a single activity log item
     */
    createActivityLogItem ({ commit }, { projectId, payload }) {

        return http.post(`projects/${projectId}/activity-log`, payload).then((response) => {
            commit(ADD_SINGLE, response.data.data)

            //Also add this item to the list
            commit(ADD_LIST, [response.data.data])
  
            return response
        })
    },

    /**
     * Add a single activity log item
     */
    updateActivityLogItem ({ commit }, { projectId, id, payload }) {

      return http.put(`projects/${projectId}/activity-log/${id}`, payload).then((response) => {
          commit(ADD_SINGLE, response.data.data)

          //Also add this item to the list
          commit(UPDATE_LIST_ITEM, [response.data.data])

          return response
      })
  },

    /**
     * Add a single activity log item
     */
    updateStatusForActivityLogItem ({ commit }, { projectId, id, payload }) {

      return http.put(`projects/${projectId}/activity-log/${id}`, payload).then((response) => {
          commit(SET_SINGLE, response.data.data)

          //Also add this item to the list
          commit(UPDATE_LIST_ITEM, [response.data.data])

          return response
      })
  },

    deleteActivityLogItem ({ commit }, {projectId, id} ) {
            
      return http.delete(`projects/${projectId}/activity-log/${id}`).then((response) => {

          commit(SET_SINGLE, {})

          //Also remove this item from the list if we have a reference for it
          commit(REMOVE_LIST_ITEM, id)

          return response
      })
    },
}

// liabilities state mutations.
const mutations = {

  /**
   * Set the list state
   * @param {*} state 
   * @param {*} list 
   */
  [SET_LIST] (state, list) {
    state.list = list
  },

  /**
   * Set the single state
   * @param {*} state 
   * @param {*} single 
   */
  [SET_SINGLE] (state, single) {
      state.single = single
  },

  /**
   * Add a single item to the state
   * @param {*} state 
   * @param {*} single 
   */
  [ADD_SINGLE] (state, single) {
      state.single = single
  },

  /**
   * Add more items to the list state
   * @param {*} state 
   * @param {*} list 
   */
  [ADD_LIST] (state, list) {
    state.list = concat(list, state.list)
  },

  /**
   * Update a single item in the list
   * @param {*} state 
   * @param {*} item 
   */
  [UPDATE_LIST_ITEM] (state, items) {
      items.forEach(item => {
          
          let index = findIndex(state.list, existing => existing.id === item.id)

          if (index === -1) {
              state.list.push(item)
          } else {
              state.list.splice(index, 1, item)
          }
      })
    },

  /**
   * Remove a single item from the list
   * @param {*} state 
   * @param {*} id 
   */
  [REMOVE_LIST_ITEM] (state, id) {
    let existingItem = findIndex(state.list, existing => existing.id === id)

    if (existingItem >= 0) {
      state.list.splice(existingItem, 1)
    }
  },

  /**
   * Set the pagination data
   * @param {*} state 
   * @param {*} pagination 
   */
  [SET_PAGINATION_DATA] (state, pagination) {
    state.pagination = pagination
  },

  /**
   * Set a property on the state.
   *
   * @return void
   */
  [SET_PROPERTY] (state, { property, value }) {
    set(state, property, value)
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
